var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDiagnosticoFiscal01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_918",
    d: "M31.3,4h-8.9V3.4c0-1.6-1.7-2.9-3.7-2.9h-1.5c-2,0-3.7,1.3-3.7,2.9V4H4.7C3.6,3.9,2.6,4.6,2.5,5.7v28 c0.1,1.1,1.1,1.9,2.2,1.7h26.7c1.1,0.1,2.1-0.7,2.2-1.7v-28C33.4,4.6,32.4,3.9,31.3,4z M15,3.4c0.1-1.1,1.1-1.9,2.2-1.8h1.5 c1.1-0.1,2.1,0.7,2.2,1.8V4H15L15,3.4z M23.8,5.2c-0.4,0.8-1.2,1.2-2.1,1.2h-7.4c-0.9,0-1.7-0.4-2.1-1.2H23.8z M32.1,33.8 c0,0.4-0.4,0.6-0.7,0.6H4.7c-0.4,0-0.7-0.2-0.7-0.6v-28c0-0.4,0.4-0.6,0.7-0.6h6c0.6,1.5,2,2.4,3.6,2.3h7.4 c1.6,0.1,3.1-0.8,3.6-2.3h6c0.4,0,0.7,0.2,0.7,0.6L32.1,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_919",
    d: "M20.9,10.7c-0.2-0.3-0.6-0.4-1-0.3c-0.2,0.1-0.3,0.2-0.4,0.3l-1.5,3.5L17.2,12c-0.2-0.3-0.6-0.5-0.9-0.4 c-0.2,0-0.3,0.1-0.4,0.3l-1.1,1.4l-0.5-3.5c-0.2-0.4-0.6-0.6-1-0.5c-0.2,0.1-0.3,0.2-0.4,0.4l-2.3,5.5l-1.5-2.7 c-0.1-0.2-0.4-0.4-0.7-0.4h-3v1.2h2.5l2,3.7c0.1,0.2,0.4,0.4,0.7,0.4h0c0.3,0,0.5-0.1,0.7-0.4l1.9-4.5l0.4,2.6 c0.1,0.4,0.5,0.6,0.8,0.5c0.2,0,0.4-0.1,0.6-0.3l1.3-1.8l1,2.8c0.1,0.3,0.4,0.4,0.7,0.4c0.3,0,0.6-0.1,0.7-0.4l1.7-3.9l0.7,1.1 c0.2,0.2,0.4,0.3,0.7,0.3h8.9v-1.2h-8.4L20.9,10.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_236",
    x: 5.4,
    y: 20.9,
    width: 25.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_237",
    x: 5.4,
    y: 23.2,
    width: 25.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_238",
    x: 5.4,
    y: 25.6,
    width: 25.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_239",
    x: 5.4,
    y: 27.9,
    width: 25.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_240",
    x: 5.4,
    y: 30.3,
    width: 25.2,
    height: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDiagnosticoFiscal01);
export default __webpack_public_path__ + "static/media/ico-diagnostico-fiscal-01.411d807d1f8046fb065ace4ae83ac896.svg";
export { ForwardRef as ReactComponent };